/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob150201Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob150201ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false,
  printIsLoading: false
});

export const whseJob150201FetchWhseJob150201Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob150201FetchWhseJob150201Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob150201AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const whseJob150201RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob150201SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob150201PrintWhseJob150201Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob150201Types.WHSE_JOB150201_RESET_TIMESTAMP]: whseJob150201ResetTimestamp,
  [WhseJob150201Types.WHSE_JOB150201_FETCH_WHSE_JOB150201_LOADING]: whseJob150201FetchWhseJob150201Loading,
  [WhseJob150201Types.WHSE_JOB150201_FETCH_WHSE_JOB150201_SUCCESS]: whseJob150201FetchWhseJob150201Success,
  [WhseJob150201Types.WHSE_JOB150201_ADD_SELECTED_DOCUMENTS]: whseJob150201AddSelectedDocuments,
  [WhseJob150201Types.WHSE_JOB150201_REMOVE_SELECTED_DOCUMENTS]: whseJob150201RemoveSelectedDocuments,
  [WhseJob150201Types.WHSE_JOB150201_SET_WORKSPACE_VISIBLE]: whseJob150201SetWorkspaceVisible,
  [WhseJob150201Types.WHSE_JOB150201_PRINT_WHSE_JOB150201_LOADING]: whseJob150201PrintWhseJob150201Loading
});
